import requestTimeout from '../../Utils/Functions/requestTimeout';
import { useState, useContext } from 'react';
import { AccountContext } from '../../AccountContext';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import { api } from 'api/api';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useModelCartao = (vals) => {
  const { user, setUser } = useContext(AccountContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [excluido, setExcluido] = useState(false);
  const [cartaoCadastrado, setCartaoCadastrado] = useState(false);
  const [retornoCartao, setRetorno] = useState('');
  const [creditCards, setCreditCards] = useState(user?.cards);
  const [error_message, setErrorMessage] = useState(null);
  const timeOutInSeconds = process.env.REACT_APP_REQUEST_TIMEOUT_IN_SECONDS;
  const navigate = useNavigate();
  const toast = useToast();

  function callToast(title, descricao, type) {
    toast({
      title: title,
      description: descricao,
      status: type,
      duration: 4000,
      isClosable: true,
      position: 'bottom',
      colorScheme: 'red',
      containerStyle: {
        paddingTop: '50px',
      },
    });
  }

  async function cadastrarCartao() {
    setLoading(true);
    const dados = vals.dados;
    const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');
    api(`${ENDPOINT}/pagamento/criar-cartao`, {
      method: 'POST',
      body: JSON.stringify({
        cpf: user?.cpf,
        number: onlyNumbers(dados.cardNumber),
        holder_name: dados.card_holder_name,
        holder_document: onlyNumbers(dados.cpf),
        exp_month: dados.expirationDate.split('/')[0],
        exp_year: dados.expirationDate.split('/')[1],
        cvv: dados.cvv,
      }),
      headers: {
        Accept: '/',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        setLoading(false);
        if (response.id) {
          api(`${ENDPOINT}/client/add_credit_card`, {
            signal: requestTimeout(timeOutInSeconds).signal,
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              paciente_id: user.id_cliente_deovita,
              first_digits: response.first_six_digits,
              last_digits: response.last_four_digits,
              brand: response.brand,
              holder_name: response.holder_name,
              holder_document: response.holder_document,
              expiration_date: `${response.exp_month.toString().padStart(2, '0')}/${(response.exp_year % 100).toString().padStart(2, '0')}`,
              card_id_pagarme: response.id,
              fingerprint_card_pagarme: null,
              default: user.cards.length > 0 ? false : true,
            }),
          })
            .catch((error) => {
              setCartaoCadastrado(false);
              setError(true);
              return;
            })
            .then((res) => {
              if (!res || !res.ok || res.status >= 400) {
                setCartaoCadastrado(false);
                setError(true);
                return;
              }
              return res.json();
            })
            .then(async (data) => {
              if (data?.success === 'false' || data?.success === false) {
                setRetorno(data?.msg);
                return;
              }
              setLoading(false);
              if (!data) return;
              if (data.success || data.success === 'true') {
                if (vals.editar) {
                  await editarCartao(data.id);
                }
                setCartaoCadastrado(true);
                setError(false);
                await searchCartoesAtualizados(user?.id_cliente_deovita)
              } else {
                setRetorno(data?.msg);
                setCartaoCadastrado(false);
                setError(true);
              }
            });
        } else {
          setCartaoCadastrado(false);
          setError(true);
          setErrorMessage(response.error.message)
        }
      })
      .catch((err) => {
        setCartaoCadastrado(false);
        setError(true);
        setErrorMessage('Não foi possível concluir a solicitação. Tente novamente mais tarde.')
      });
  }

  async function editarCartao(cardId) {
    api(`${ENDPOINT}/client/desativar-cartao-anterior`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({
        card_id_pagarme: vals?.cartaoState?.paciente_cartao_credito_pagarme_id,
        paciente_id: vals?.cartaoState?.paciente_id,
        card_id_novo: cardId,
      }),
    })
      .catch((error) => {
        setLoading(false);
        setError(true);
        return;
      })
      .then((res) => {
        if (!res || !res.ok || res.status >= 400) {
          setLoading(false);
          setError(true);
          callToast('Erro', 'Não foi possível definir o cartão como principal.', 'error');
          return;
        }
        return res.json();
      })
      .then(async (resposta) => {
       
      });
  }

  async function excluirCartao() {
    if (!vals.cardId) {
      setLoading(false);
      setError(true);
      setExcluido(false);
      return;
    }
    setLoading(true);
    setErrorMessage(null);
    api(`${ENDPOINT}/client/rm_credit_card/${vals.cardId}`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    })
      .catch((error) => {
        setLoading(false);
        setError(true);
        setExcluido(false);
        return;
      })
      .then((res) => {
        if (!res || !res.ok || res.status >= 400) {
          setLoading(false);
          //navigate('/perfil/pagamento/status-cartao', { state: { sucesso: false } });
          return;
        }
        return res.json();
      })
      .then((data) => {
        setLoading(false);
        if (!data) return;
        if (data.success) {
          let newCards = user.cards.filter((creditCard) => creditCard.paciente_cartao_credito_pagarme_id !== vals.cardId);
          setUser((prevState) => ({ ...prevState, cards: newCards }));
          //navigate('/perfil/pagamento/status-cartao', { state: { sucesso: true } });
          setError(false);
          setExcluido(true);
        } else {
          //navigate('/perfil/pagamento/status-cartao', { state: { sucesso: false } });
          setLoading(false);
          setError(true);
          setExcluido(false);
          setErrorMessage(
            data.blocked ? data.msg : 'Não foi possível excluir o cartão. Tente novamente mais tarde.'
          );
        }
      });
  }

  async function definirCartaoPrincipal() {
    const paciente_cartao_credito_pagarme_id = vals.paciente_cartao_credito_pagarme_id;
    api(`${ENDPOINT}/client/stamp-default-card/${paciente_cartao_credito_pagarme_id}`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    })
      .catch((error) => {
        setLoading(false);
        setError(true);
        return;
      })
      .then((res) => {
        if (!res || !res.ok || res.status >= 400) {
          setLoading(false);
          setError(true);
          callToast('Erro', 'Não foi possível definir o cartão como principal.', 'error');
          return;
        }
        return res.json();
      })
      .then((data) => {
        setLoading(false);
        if (!data) return;
        if (data.success) {
          setError(true);
          setCreditCards((cardsList) => {
            return cardsList.map((card) => ({
              ...card,
              default: card.paciente_cartao_credito_pagarme_id === paciente_cartao_credito_pagarme_id,
            }));
          });
          setUser((user) => {
            return {
              ...user,
              cards: creditCards,
            };
          });
          callToast('Sucesso', 'Cartão principal definido com sucesso.', 'success');
          navigate('/perfil/menu-pagamentos');
        } else {
          callToast('Erro', 'Não foi possível definir o cartão como principal.', 'error');
          setLoading(false);
        }
      });
  }

  async function searchCartoesAtualizados(paramId) {
    api(`${ENDPOINT}/clients/getCreditCardsByClient/${vals?.clientId ? vals?.clientId : paramId}`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    })
      .catch((error) => {
        setLoading(false);
        setError(true);
        return;
      })
      .then(async (res) => {
        if (!res || !res.ok || res.status >= 400) {
          setLoading(false);
          setError(true);
          return;
        }
        return await res.json();
      })
      .then(async (resposta) => {
        setUser((prevState) => {
          return {
            ...prevState,
            cards: resposta,
          };
        });
      });
  }

  return {
    cadastrarCartao,
    editarCartao,
    excluirCartao,
    definirCartaoPrincipal,
    loading,
    error,
    excluido,
    cartaoCadastrado,
    retornoCartao,
    searchCartoesAtualizados,
    error_message
  };
};

export default useModelCartao;
